
<template>
	<div>
	<b-card no-body class="mb-1">
		<b-card-header header-tag="header" class="p-0">
		<b-button block v-b-toggle.accordion-vclean-code-search variant="light">
			Veja como é fácil instalar sua Palheta VClean
		</b-button>
		</b-card-header>
		<b-collapse id="accordion-vclean-code-search"  v-model="accordionVcleanExactCodesSearchVisible"  @show="accordionvcleanExactCodesSearchShown" class="mt-1">
		<b-card-body class="p-1 pb-2">
			<b-container fluid>
			<b-row>
				<b-col cols="4" sm="4" md="3" lg="2" xl="2" class="d-flex align-items-center">
				<label class="mb-0" for="input-vclean-code">Código VClean Exact</label>
				</b-col>
				<b-col cols="8" sm=8 md="9" lg="10" xl="10">
				<vue-bootstrap-typeahead id="input-vclean-code" placeholder="Exemplo: VCE20 | CNX5" v-model="vcleanExactCode" @keydown.enter="search" :data="vcleanExactCodes" @hit="search" />
				<!--<b-form-input id="input-vclean-code" type="text" v-model="vcleanExactCodes" @keydown.enter="search"></b-form-input>-->
				</b-col>
			</b-row>
			</b-container>
		</b-card-body>
		</b-collapse>
	</b-card>
	<b-card no-body class="mb-1" v-if="fullPathURL != '/codigovclean'">
		<b-card-header header-tag="header" class="p-0">
		<b-button block v-b-toggle.accordion-vehicle-search variant="light">
			Busca por Veículo
		</b-button>
		</b-card-header>
		<b-collapse id="accordion-vehicle-search" v-model="accordionVehicleSearchVisible" @show="accordionVehicleSearchShown" class="mt-1">
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-brand variant="light" class="subitem">
				{{ selectedBrand || 'MARCA' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-brand">
			<b-card-body>
				<b-list-group>
				<b-list-group-item button
					v-for="(brand, index) in brands"
					v-b-toggle="'accordion-brand'"
					:key="index"
					@click="onSelectedBrand(brand)"
				>
					{{ brand.brand }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-model variant="light" class="subitem">
				{{ selectedModel || 'MODELO' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-model">
			<b-card-body>
				<b-list-group>
				<b-list-group-item
					button
					v-for="(model, index) in models"
					v-b-toggle="'accordion-model'"
					:key="index"
					@click="onSelectedModel(model)"
				>
					{{ model.model }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		<b-card no-body class="mb-1">
			<b-card-header header-tag="header" class="p-0">
			<b-button block v-b-toggle.accordion-year variant="light" class="subitem">
				{{ selectedYear.displayValue || 'ANO' }}
			</b-button>
			</b-card-header>
			<b-collapse id="accordion-year">
			<b-card-body>
				<b-list-group>
				<b-list-group-item
					button
					v-for="(year, index) in years"
					v-b-toggle="'accordion-year'"
					:key="index"
					:disabled="!selectedModel"
					@click="onSelectedYear(year)"
				>
					{{ year.displayValue }}
				</b-list-group-item>
				</b-list-group>
			</b-card-body>
			</b-collapse>
		</b-card>
		</b-collapse>
	</b-card>
	<div class="buttons-container">
		<b-button @click="clear()" variant="outline-light" class="button-search">LIMPAR</b-button>
		<b-button @click="search"
		:disabled="!(detailURL && accordionVehicleSearchVisible) && !(vcleanExactCodes && accordionVcleanExactCodesSearchVisible) && !(competitorCode && accordionCompetitorCodeSearchVisible)"
		variant="outline-light" 
		class="button-search"
		>
			BUSCAR
		</b-button>
	</div>
</div>
</template>
  
<script>
/* eslint-disable */
export default {
	name: 'ExactSearch',
	props: {
		data: Array,
		exactData: Array,
		convertionsData: Array,
		applicationsData: Array,
		vcleanExactCodes: Array,
		codigosLimpadores: Array,
		codigosConectores: Array,
		competitorCodes: Array
	},
  
	mounted() {
		this.init(this.exactData && this.exactData.length ? this.exactData : this.data);
		let self = this;
		window.addEventListener('keyup', function(e) {
			if (e.key === 'Enter') {
				self.search();
				self.clear()
			}
		});
	},
  
	data() {
		return {
			accordionVehicleSearchVisible: false,
			accordionVcleanExactCodesSearchVisible: true,
			accordionCompetitorCodeSearchVisible: false,
			fullPathURL: this.$router.currentRoute.fullPath,
			vcleanExactCode: '',
			competitorCode: '',
			outputvcleanExactCodes: '',
			detailURL: '',
			selectedBrand: '',
			selectedModel: '',
			selectedYear: {},
			brands: [],
			models: [],
			years: []
		};
	},
	
	watch: {
		'data': function(data) {
			this.init(this.exactData && this.exactData.length ? this.exactData : data);
		},
		'exactData': function(exactData) {
			this.init(exactData && exactData.length ? exactData : this.data);
		}
	},
	
	methods: {
		buildBrandsFromExactData: function(exactData) {
			const groupedBrands = new Map();

			for (const row of exactData || []) {
				if (!row || !row.marca || !row.veiculo) {
					continue;
				}

				if (!groupedBrands.has(row.marca)) {
					groupedBrands.set(row.marca, { brand: row.marca, models: [] });
				}

				const brandEntry = groupedBrands.get(row.marca);
				let modelEntry = brandEntry.models.find((model) => model.model === row.veiculo);

				if (!modelEntry) {
					modelEntry = { model: row.veiculo, items: [] };
					brandEntry.models.push(modelEntry);
				}

				modelEntry.items.push({
					brand: row.marca,
					model: row.veiculo,
					from: row.de,
					to: row.ate,
					...row
				});
			}

			return Array.from(groupedBrands.values());
		},

		init: function(data) {
			this.brands = [];
			this.models = [];
			this.years = [];
			this.selectedBrand = '';
			this.selectedModel = '';
			this.selectedYear = {};

			if (!data || !data.length) {
				this.years = [ { displayValue: 'Selecione uma marca ou modelo' } ];
				return;
			}

			if (data[0] && data[0].brand && data[0].models) {
				this.brands = data;
			} else {
				this.brands = this.buildBrandsFromExactData(data);
			}

			for (const brand of this.brands) {
				this.models = [ ...this.models, ...brand.models ];
			}

			this.years = [ { displayValue: 'Selecione uma marca ou modelo' } ];
		},
		
		onSelectedBrand: function(selected) {
			this.models = [];
			this.selectedModel = '';
			this.selectedBrand = selected.brand;
		
			const filteredBrands = this.brands.filter(item => item.brand === this.selectedBrand);
		
			if (filteredBrands.length) {
				for (const brand of filteredBrands) {
					this.models = [ ...this.models, ...brand.models ];
				}
			}
		},
		
		onSelectedModel: function(selected) {
			this.years = [];
			this.selectedModel = selected.model;
		
			const filteredBrand = this.brands.find(function(item) {
				for (const model of item.models) {
					if (model.model === selected.model) {
						return model;
					}
				}
			});
		
			if (filteredBrand) {
				this.selectedBrand = filteredBrand.brand;
			}
		
			if (selected.items.length) {
				for (const year of selected.items) {
					const modifiedYear = { 
						brand: this.selectedBrand, 
						model: this.selectedModel,
						displayValue: `DE: ${year.from} ATÉ: ${year.to}`,
						...year
					};
					this.years = [ ...this.years, modifiedYear ];
				}
			}
		},
		
		onSelectedYear: function(selected) {
			this.selectedYear = selected;
		
			const normalizedBrand = this.selectedBrand.replace(new RegExp(/\//, 'g'), '%2F');
			const normalizedModel = this.selectedModel.replace(new RegExp(/\//, 'g'), '%2F');
			this.detailURL = `exact/brand/${normalizedBrand}/model/${normalizedModel}/year/${this.selectedYear.from}-${this.selectedYear.to}`;
		},
  
		search: function() {
			if (this.accordionVehicleSearchVisible) {
				this.$router.push(this.detailURL);
				return;
			}
  
			if (this.accordionVcleanExactCodesSearchVisible && this.fullPathURL != '/codigovclean') {
				if (this.vcleanExactCode) {
					this.$router.push(`/exact/${this.vcleanExactCode}`);
					return;
				}
			}
		},
		
		clear: function() {
			this.accordionVehicleSearchVisible = false,
			this.accordionVcleanExactCodesSearchVisible = false,
			this.accordionCompetitorCodeSearchVisible = false,
			this.vcleanExactCode = '';
			this.competitorCode = '';
			this.selectedBrand = '';
			this.selectedModel = '';
			this.selectedYear = {};
			this.brands = [];
			this.models = [];
			this.years = [];
			this.init(this.exactData && this.exactData.length ? this.exactData : this.data);
		},
  
		accordionVehicleSearchShown: function() {
			this.accordionVcleanExactCodesSearchVisible = false;
			this.accordionCompetitorCodeSearchVisible = false;
		},
  
		accordionvcleanExactCodesSearchShown: function() {
			this.accordionVehicleSearchVisible = false;
			this.accordionCompetitorCodeSearchVisible = false;
		},
  
		accordionCompetitorCodeSearchShown: function() {
			this.accordionVehicleSearchVisible = false;
			this.accordionVcleanExactCodesSearchVisible = false;
		}
	}
};
</script>
  
<style>
	.card-body {
	padding: 0 !important;
	}
	.list-group-item {
	padding: 0.60rem 1.25rem !important;
	}
	.buttons-container {
	display: flex;
	justify-content: space-between;
	}
	.btn-block {
	padding: 1.25rem !important;
	}
	.button-search {
	width: 49.5% !important;
	padding: 1.25rem 0.75rem !important;
	background-color: #ddd !important;
	border-color: #004e64 !important;
	}
	.button-search:hover {
	background-color: #ccc !important;
	}
	.subitem {
	color: #004e64 !important;
	background-color: #f8f9fa !important;
	}
</style>
